<template>
  <svg class="archive-entry-mark" :class="[kind, { 'is-active': active }]" viewBox="20 5 132 90" fill="none" aria-hidden="true" focusable="false">
    <template v-if="kind === 'search'">
      <g class="source-sheet">
        <path d="M42 12h50l12 12v59H42z" class="paper" />
        <path d="M92 12v12h12" class="fold" />
        <path d="M52 32h29v22H52z" class="paper-inset" />
      </g>
      <g class="search-lens">
        <path d="m117 69 18 18a5 5 0 0 1-7 7l-18-18Z" class="handle" />
        <circle cx="103" cy="59" r="21" class="lens" />
        <path d="M87 59a16 16 0 0 1 16-16v16Z" class="lens-light" />
      </g>
    </template>
    <template v-else-if="kind === 'ask'">
      <g class="answer-source">
        <path d="M59 43h76v43H59z" class="paper-under" />
      </g>
      <g class="answer-sheet">
        <path d="M33 18h87a3 3 0 0 1 3 3v44a3 3 0 0 1-3 3H62L45 81V68H33a3 3 0 0 1-3-3V21a3 3 0 0 1 3-3Z" class="paper" />
      </g>
    </template>
    <template v-else>
      <g class="reading-left">
        <path d="M35 16c18 0 34 4 48 12v59c-15-8-32-12-48-12Z" class="paper" />
      </g>
      <g class="reading-right">
        <path d="M83 28c14-8 30-12 48-12v59c-17 0-33 4-48 12Z" class="paper" />
        <path d="M96 35c8-3 16-5 25-6v17c-9 1-17 3-25 6Z" class="excerpt" />
        <path d="m117 17 7-1v17l-3-2-4 3Z" class="bookmark" />
      </g>
    </template>
  </svg>
</template>

<script>
export default {
  name: 'HomeArchiveEntryMark',
  props: { kind: { type: String, required: true }, active: Boolean },
};
</script>

<style scoped>
.archive-entry-mark { display: block; width: 100%; height: 100%; overflow: visible; color: var(--ink,#333); --mark-surface: var(--surface,#f7f7f5); --mark-paper: color-mix(in srgb, var(--mark-surface) 92%, currentColor); --mark-paper-light: color-mix(in srgb, var(--mark-surface) 95%, currentColor); --mark-accent: color-mix(in srgb, var(--mark-surface) 66%, rgb(var(--site-accent-rgb))); --mark-ease: cubic-bezier(.22,1,.36,1); }
.paper { fill: var(--mark-paper); }
.paper-under { fill: color-mix(in srgb, var(--mark-surface) 78%, rgb(var(--site-accent-rgb))); }
.fold { fill: color-mix(in srgb, var(--mark-surface) 88%, currentColor); }
.paper-inset { fill: color-mix(in srgb, var(--mark-surface) 98%, currentColor); }
.excerpt { fill: var(--mark-accent); }
.source-sheet { transform: rotate(-8deg); transform-origin: 75px 50px; transition: transform 320ms var(--mark-ease); }
.lens { fill: var(--mark-accent); }
.lens-light { fill: var(--mark-surface); opacity: .42; }
.handle { fill: color-mix(in srgb, var(--mark-surface) 80%, currentColor); }
.search-lens { transition: transform 280ms var(--mark-ease); }
.search.is-active .source-sheet { transform: translate(-3px,1px) rotate(-3deg); }
.search.is-active .search-lens { transform: translate(-7px,-4px); }
.answer-sheet, .answer-source { transition: transform 320ms var(--mark-ease); }
.answer-sheet .paper { fill: var(--mark-paper-light); }
.ask.is-active .answer-sheet { transform: translate(-2px,-3px); }
.ask.is-active .answer-source { transform: translate(3px,2px); }
.reading-left, .reading-right { transform-origin: 83px 50px; transition: transform 280ms var(--mark-ease); }
.reading-right .paper { fill: var(--mark-paper-light); }
.bookmark { fill: color-mix(in srgb, var(--mark-surface) 48%, rgb(var(--site-accent-rgb))); }
.view.is-active .reading-left { transform: skewY(-2deg); }
.view.is-active .reading-right { transform: skewY(2deg); }
@media (prefers-reduced-motion: reduce) { .archive-entry-mark * { transition: none; transform: none !important; } }
</style>
